<section id="project1" class="projects position-relative" data-scroll-nav="0">
	<div class="container-fluid padding-top">
		<div class="container">
			<div class="mx-auto">
				<div class="row">
					<div class="col-xl-8 col-md-8 col-sm-6" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
						<div class="d-flex flex-column h-100 service-content">
							<h5 data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"
								class="text-uppercase fontsize12 semibold m-0" style="letter-spacing: 1.2px">
								LUXURY JEWELLERY BRAND
							</h5>
							<h1 class="size90 text-uppercase light postion">D'NOUR DUBAI</h1>
							<div class="points">
								<p class="lufgaregular size24">
									D’NOUR is a Dubai-based jewellery brand that places women at
									the forefront.
								</p>
							</div>
						</div>
					</div>
					<div class="col-xl-4 col-md-4 col-sm-6 my-auto">
						<div class="d-flex flex-column justify-content-center align-items-sm-end">
							<div class="list-block">
								<h3 class="mt-0" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
									<a class="text-capitalize lufgaregular size18">Branding</a>
								</h3>
								<h3 class="mt-0" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="150">
									<a class="text-capitalize lufgaregular size18">motion graphics</a>
								</h3>
								<h3 class="mt-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200">
									<a class="text-capitalize lufgaregular size18">UI/UX Design</a>
								</h3>
								<h3 class="mt-0" data-aos="fade-up" data-aos-duration="2500" data-aos-delay="250">
									<a class="text-capitalize lufgaregular size18">ecommerce</a>
								</h3>
								<h3 class="mt-0" data-aos="fade-up" data-aos-duration="2500" data-aos-delay="250">
									<a class="text-capitalize lufgaregular size18">seo</a>
								</h3>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="d-xxl-flex d-none position-absolute custom-social-con" data-aos="fade-up" data-aos-duration="2000"
			data-aos-delay="100">
			<ul class="custom-social">
				<li>
					<a href="https://www.instagram.com/pixtar.ae/" target="_blank">
						<img src="{{ baseUrl }}/img/home/social-media/instagram.svg" alt="Top creative agencies in Dubai"
							class="social" loading="lazy" />
					</a>
				</li>
				<li>
					<a href="https://www.facebook.com/pixtar.ae/" target="_blank">
						<img src="{{ baseUrl }}/img/home/social-media/facebook.svg" alt="Best design agency" class="social"
							loading="lazy" />
					</a>
				</li>
				<li>
					<a href="https://www.linkedin.com/company/pixtar-ae/" target="_blank">
						<img src="{{ baseUrl }}/img/home/social-media/linkedin.svg" alt="Website development company Dubai"
							class="social" loading="lazy" />
					</a>
				</li>
			</ul>
		</div>

		<div class="d-xxl-flex d-none position-absolute custom-whatsapp-con">
			<ul class="custom-social">
				<li>
					<a class="whatsapp-icon2 slideUpReturn tabmob" href="https://wa.me/+971527930781" target="_blank">
						<img src="{{ baseUrl }}/img/home/whatsapp.svg" alt="Top branding agency in Dubai" class="social2"
							loading="lazy" />
					</a>
				</li>
			</ul>
		</div>
	</div>
</section>

<section data-scroll-nav="1" class="py-0 py-md-5" style="overflow: inherit">
	<div class="container">
		<div class="row">
			<div class="col-12 bannerimg pt-md-5 px-0 px-md-3" data-aos="fade-up" data-aos-duration="2000"
				data-aos-delay="100">
				<div class="slider-container" #sliderRef>
					<div class="before-after-slider">
						<img src="{{ baseUrl }}/img/demo/before-pixtar.jpg" alt="beforeAlt" class="before-pixtar" />

						<div class="after-container" [style.clip-path]="'inset(0 ' + (100 - sliderPosition) + '% 0 0)'">
							<img src="{{ baseUrl }}/img/demo/after-pixtar.jpg" alt="afterAlt" class="after-pixtar" />
						</div>

						<span #handleRef class="handle" [class.dragging]="dragging" [style.left.%]="sliderPosition"
							(mousedown)="onMouseDown($event)" (touchstart)="onMouseDown($event)"></span>
					</div>
				</div>
			</div>
		</div>

		<div class="row" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
			<div class="col-12 px-4 px-md-3">
				<div class="d-flex flex-column row-gap-2 pt-5">
					<p class="lufgaregular">
						<span class="lufgamedium">Client: </span> D'NOUR
					</p>
					<p class="lufgaregular">
						<span class="lufgamedium">Industry: </span> Premium Jewellery Brand
					</p>
					<p class="lufgaregular">
						<span class="lufgamedium">Services Provided: </span>
						Branding, Animation, UI/UX Design, E-commerce, and SEO
					</p>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="section about-project" data-scroll-nav="2">
	<div class="container px-4 px-md-3">
		<div class="row">
			<div class="col-12">
				<h5 class="text-uppercase fontsize12 semibold m-0" style="letter-spacing: 1.2px" data-aos="fade-up"
					data-aos-duration="2000" data-aos-delay="100">
					about the project
				</h5>
			</div>
			<div class="col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12 mb-2 mb-md-0 mb-3" data-aos="fade-up"
				data-aos-duration="2000" data-aos-delay="100">
				<h1 class="size55 text-capitalize light">The Challenge</h1>
			</div>
			<div class="col-xxl-7 col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12" data-aos="fade-up" data-aos-duration="2000"
				data-aos-delay="100">
				<div class="content pt-3 p-lg-0">
					<p class="mb-4 mb-md-5 lufgaregular">
						<span class="lufgamedium"> Pixtar </span>, a
						<span class="lufgamedium"> leading web development agency,</span>
						partnered with <span class="lufgamedium">D'NOUR</span>, a
						<span class="lufgamedium">Dubai-based jewellery brand</span>
						symbolizing women empowerment. Inspired by the Rose,
						<span class="lufgamedium">D'NOUR’s designs reflect elegance</span>,
						craftsmanship, and a powerful message.
					</p>
					<p class="mb-0 lufgaregular">
						<span class="lufgamedium">Pixtar</span> aimed to
						<span class="lufgamedium">establish D'NOUR’s</span> online presence
						in the competitive
						<span class="lufgamedium">UAE and USA jewellery market</span>, where
						span brands made
						<span class="lufgamedium">organic SEO a challenging</span> task for
						the newly developed website.
					</p>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- branding -->
<section class="branding" id="brandings" data-scroll-nav="3">
	<div class="container">
		<div class="row">
			<div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11">
				<div class="row">
					<div class="col-xxl-8 col-xl-8 col-lg-8 col-md-10 col-sm-10 col-11 px-4 px-md-3" data-aos="fade-up"
						data-aos-duration="2000" data-aos-delay="100">
						<div class="content">
							<h1 class="size55 text-uppercase light">Branding</h1>
							<p class="lufgaregular size24">
								D’NOUR is a Dubai-based jewellery brand that places women at the
								forefront.
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-12 px-0 px-md-3" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
				<div class="imglist h-100 mb-3">
					<img src="{{ baseUrl }}/img/demo/dnour_branding_1.jpg" alt="best web design company in dubai" width=""
						height="" loading="lazy" />
				</div>
			</div>
			<div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 px-md-3">
				<div class="row">
					<div class="col-xl-6 col-lg-6 col-md-6 mx-lg-auto mb-3 mb-md-0 px-4 px-md-3" data-aos="fade-up"
						data-aos-duration="2000" data-aos-delay="100">
						<img src="{{ baseUrl }}/img/demo/dnour_brand_color.jpg" alt="web
						designing agency dubai" width="" class="h-100 m-0" height="" loading="lazy" />
					</div>
					<div class="col-xl-6 col-lg-6 col-md-6 px-4 px-md-3" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<div class="list">
							<img src="{{ baseUrl }}/img/demo/dnour_brand_typo_1.jpg" alt="Top
							branding agency in Dubai" width="" height="" loading="lazy" />
							<img class="mb-0" src="{{ baseUrl }}/img/demo/dnour_brand_typo_2.jpg"
								alt="website development company dubai" width="" height="" loading="lazy" />
						</div>
					</div>
				</div>
			</div>
			<div class="col-xxl-7 col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12 ms-auto px-4 px-md-3 pt-md-5 pt-3"
				data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
				<div class="content">
					<p class="mb-4 mb-md-5 lufgaregular">
						<span class="lufgamedium"> Pixtar </span>, a
						<span class="lufgamedium"> leading web development agency, </span>
						partnered with <span class="lufgamedium">D'NOUR</span>, a
						<span class="lufgamedium">Dubai-based jewellery brand</span>
						symbolizing women empowerment. Inspired by the Rose,
						<span class="lufgamedium">D'NOUR’s designs reflect elegance</span>,
						craftsmanship, and a powerful message.
					</p>
					<p class="mb-0 lufgaregular">
						<span class="lufgamedium">Pixtar</span> aimed to
						<span class="lufgamedium">establish D'NOUR’s</span> online presence
						in the competitive
						<span class="lufgamedium">UAE and USA jewellery market</span>, where
						span brands made
						<span class="lufgamedium">organic SEO a challenging</span> task for
						the newly developed website.
					</p>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- motion graphics -->
<section class="motion-graphics" id="motion-graphics" data-scroll-nav="3">
	<div class="container">
		<div class="row">
			<div class="col-xxl-9 col-xl-10 col-lg-11 col-md-12 col-sm-12 col-12">
				<div class="row">
					<div class="col-xxl-8 col-xl-8 col-lg-8 col-md-10 col-sm-10 col-12 px-4 px-md-3" data-aos="fade-up"
						data-aos-duration="2000" data-aos-delay="100">
						<div class="content">
							<h1 class="size55 light">Motion Graphics</h1>
							<p class="lufgaregular size24">
								D’NOUR is a Dubai-based jewellery brand that places women at the
								forefront.
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-12 px-0 px-md-3" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
				<div class="imglist mb-3">
					<video #myVideo width="100%" muted autoplay (click)="playInFullscreenWithAudio()" style="cursor: pointer"
						loading="lazy">
						<source src="{{ baseUrl }}/img/demo/dnour_motion_graphics.mp4" type="video/mp4" />
						Your browser does not support the video tag.
					</video>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- ui / ux design -->
<section class="ui-ux pt-5" id="ui-ux" data-scroll-nav="8">
	<div class="container">
		<div class="row">
			<div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
				<div class="row mb-4">
					<div class="col-xxl-6 col-xl-6 col-lg-8 col-md-10 col-sm-10 col-10 px-4 px-md-3" data-aos="fade-up"
						data-aos-duration="2000" data-aos-delay="100">
						<div class="content">
							<h1 class="size55 mb-2 light">UI/UX Design</h1>
							<p class="lufgaregular size24">
								D’NOUR is a Dubai-based jewellery brand that places women at the
								forefront.
							</p>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-12 mx-lg-auto px-0 px-md-3" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<img style="padding-bottom: 30px" src="{{ baseUrl }}/img/demo/dnour_uiux_1.jpg "
							alt="web designing agency dubai" width="" height="" loading="lazy" />
					</div>
					<div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 px-4 px-md-3">
						<div class="row">
							<div class="col-xl-6 col-lg-6 col-md-6 mx-lg-auto pb-4 pb-md-0" data-aos="fade-up"
								data-aos-duration="2000" data-aos-delay="100">
								<img src="{{ baseUrl }}/img/demo/dnour_uiux_2.jpg" alt="web designing agency dubai" width=""
									class="h-100 m-0" height="" loading="lazy" />
							</div>
							<div class="col-xl-6 col-lg-6 col-md-6" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
								<img src="{{ baseUrl }}/img/demo/dnour_uiux_3.jpg" alt="web designing agency dubai" width=""
									class="h-100 m-0" height="" loading="lazy" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-xxl-7 col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12 pt-md-5 pt-3 ms-auto px-4 px-md-3"
				data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
				<div class="content">
					<p class="mb-4 mb-md-5 lufgaregular">
						<span class="lufgamedium"> Pixtar </span>, a
						<span class="lufgamedium"> leading web development agency, </span>
						partnered with <span class="lufgamedium">D'NOUR</span>, a
						<span class="lufgamedium">Dubai-based jewellery brand</span>
						symbolizing women empowerment. Inspired by the Rose,
						<span class="lufgamedium">D'NOUR’s designs reflect elegance</span>,
						craftsmanship, and a powerful message.
					</p>
					<p class="mb-0 lufgaregular">
						<span class="lufgamedium">Pixtar</span> aimed to
						<span class="lufgamedium">establish D'NOUR’s</span> online presence
						in the competitive
						<span class="lufgamedium">UAE and USA jewellery market</span>, where
						span brands made
						<span class="lufgamedium">organic SEO a challenging</span> task for
						the newly developed website.
					</p>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- Ecommerce -->
<section class="ecommerce" id="ecommerce" data-scroll-nav="8">
	<div class="container">
		<div class="row">
			<div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mx-md-auto">
				<div class="row mb-4">
					<div class="col-xxl-6 col-xl-6 col-lg-8 col-md-10 col-sm-10 col-10 px-4 px-md-3" data-aos="fade-up"
						data-aos-duration="2000" data-aos-delay="100">
						<div class="content">
							<h1 class="size55 mb-2 light">E-commerce</h1>
							<p class="lufgaregular size24">
								D’NOUR is a Dubai-based jewellery brand that places women at the
								forefront.
							</p>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-12 mx-lg-auto pb-4 px-0 px-md-3" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<img src="{{ baseUrl }}/img/demo/dnour_ecomm_1.jpg" alt="web designing agency dubai" width=""
							class="h-100 m-0" height="" loading="lazy" />
					</div>
					<div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 px-4 px-md-3">
						<div class="row">
							<div class="col-xl-6 col-lg-6 col-md-6 mx-lg-auto pb-3 pb-md-0" data-aos="fade-up"
								data-aos-duration="2000" data-aos-delay="100">
								<img src="{{ baseUrl }}/img/demo/dnour_ecomm_2.jpg" alt="web designing agency dubai" width=""
									class="h-100 m-0" height="" loading="lazy" />
							</div>
							<div class="col-xl-6 col-lg-6 col-md-6" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
								<img src="{{ baseUrl }}/img/demo/dnour_ecomm_3.jpg" alt="web designing agency dubai" width=""
									class="h-100 m-0" height="" loading="lazy" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-xxl-7 col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12 pt-md-5 pt-3 ms-auto px-4 px-md-3"
				data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
				<div class="content">
					<p class="mb-4 mb-md-5 lufgaregular">
						<span class="lufgamedium"> Pixtar </span>, a
						<span class="lufgamedium"> leading web development agency,</span>
						partnered with <span class="lufgamedium">D'NOUR</span>, a
						<span class="lufgamedium">Dubai-based jewellery brand</span>
						symbolizing women empowerment. Inspired by the Rose,
						<span class="lufgamedium">D'NOUR’s designs reflect elegance</span>,
						craftsmanship, and a powerful message.
					</p>
					<p class="mb-0 lufgaregular">
						<span class="lufgamedium">Pixtar</span> aimed to
						<span class="lufgamedium">establish D'NOUR’s</span> online presence
						in the competitive
						<span class="lufgamedium">UAE and USA jewellery market</span>, where
						span brands made
						<span class="lufgamedium">organic SEO a challenging</span> task for
						the newly developed website.
					</p>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- Successful story sections-->
<section class="success-story">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-md-10 col-sm-11 col-11 mx-auto px-md-3">
				<div class="row align-items-center">
					<div class="col-lg-3 col-md-5 col-sm-5 text-center" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<img class="w-auto" src="{{ baseUrl }}/img/demo/dnour_feedback.jpg" alt="web designing agency dubai" />
					</div>
					<div class="col-lg-9 col-md-7 col-sm-7 mt-sm-0 mt-3">
						<div class="slidecontent ms-md-5">
							<h5 class="fontsize12 textcolor1 semibold" data-aos="fade-up" data-aos-duration="2000"
								data-aos-delay="100" style="letter-spacing: 1.2px">
								Hiral Krupesh . Founder & Creative Director . Carat Craft
								Jewellery
							</h5>
							<h4 class="textcolor1 size36 my-4 text-uppercase medium" data-aos="fade-up" data-aos-duration="2000"
								data-aos-delay="100">
								I HIGHLY RECOMMEND PIXTAR IF YOU ARE LOOKING TO REVAMP AND
								ELEVATE YOUR BRAND
							</h4>
							<p class="size18 textcolor3 lufgaregular d-none d-md-block" data-aos="fade-up" data-aos-duration="2000"
								data-aos-delay="100">
								“ Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
								diam nonumy eirmod tempor invidunt ut labore et dolore magna
								aliquyam erat, sed diam voluptua. At vero eos et accusam et
								justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
								takimata sanctus est.”
							</p>
						</div>
					</div>
					<div class="col-md-12 d-md-none mt-3">
						<p class="size18 textcolor3" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							“ Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
							diam nonumy eirmod tempor invidunt ut labore et dolore magna
							aliquyam erat, sed diam voluptua. At vero eos et accusam et justo
							duo dolores et ea rebum. Stet clita kasd gubergren, no sea
							takimata sanctus est.”
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- next project -->
<section class="next pb-0" data-aos="fade-up" data-aos-duration="2000">
	<div class="container">
		<div class="border border-top-3 border-dark border-bottom-3 border-start-0 border-end-0 py-4 px-4 px-md-3">
			<div class="row">
				<div class="col-12 col-lg-6 my-auto pb-4" data-aos="fade-up" data-aos-duration="2000">
					<h5 class="text-uppercase semibold m-0 fontsize12">
						Next Case Study
					</h5>
					<h1 class="size55 text-capitalize light postion2">Detail Master</h1>
				</div>
				<div class="col-12 col-lg-6">
					<a href="{{ Url }}/project-details/pakhis" class="font-bold border-radius-25" data-aos="fade-up"
						data-aos-duration="2000">
						<img src="{{ baseUrl }}/img/demo/dnour_next_project.jpg" alt="Best Web Designers in Dubai" width="280"
							loading="lazy" />
					</a>
				</div>
			</div>
		</div>
	</div>
</section>